export const getTime = () => {
  const date = new Date();
  const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const minutes =
    date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  return `${hours}:${minutes}`;
};

export const copyToClipBoard = (textToCopy) => {
  navigator.clipboard.writeText(textToCopy);
  alert("Copied to clipboard: " + textToCopy);
};
